import { useLanguage } from "@/context/LanguageContext";

export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {/* H3 · Cut-out Door — obsidian frame, white house, dark T-door cut-out */}
    <rect width="100" height="100" rx="24" fill="#0B1320" />
    <path d="M50 14 L86 44 L86 84 L14 84 L14 44 Z" fill="#FAF9F6" />
    <rect x="28" y="50" width="44" height="9" fill="#0B1320" />
    <rect x="44" y="50" width="12" height="34" fill="#0B1320" />
  </svg>
);

/* Compact monogram-only variant */
export const LogoMonogram = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <rect width="100" height="100" rx="24" fill="#0B1320" />
    <path d="M50 14 L86 44 L86 84 L14 84 L14 44 Z" fill="#FAF9F6" />
    <rect x="28" y="50" width="44" height="9" fill="#0B1320" />
    <rect x="44" y="50" width="12" height="34" fill="#0B1320" />
  </svg>
);

export const LogoFull = ({ className = "" }) => {
  const { lang } = useLanguage();
  return (
    <div
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid="brand-logo"
    >
      <LogoMark size={44} />
      <div className="flex flex-col leading-none">
        <span
          className="text-[22px] font-black tracking-tight text-[#0B1320]"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Talibnaz
        </span>
        <span
          className="text-[13px] font-bold text-[#0B1320]/70 mt-0.5"
          style={{ fontFamily: "Tajawal, sans-serif" }}
          dir="rtl"
        >
          طالبناز
        </span>
      </div>
    </div>
  );
};
